exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-request-dialog {\n  display: block;\n}\nfi-request-dialog .fi-dialog {\n  max-width: 510px;\n}\nfi-request-dialog .fi-dialog textarea {\n  border-bottom: none;\n  min-height: 150px;\n  padding: 5px 15px;\n}\nfi-request-dialog .fi-dialog .fi-checkbox {\n  min-height: 28px;\n}\nfi-request-dialog .fi-dialog {\n  /* Loader */\n}\nfi-request-dialog .fi-dialog .fitit-loader {\n  width: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nfi-request-dialog .fi-dialog .fitit-loader .md-container {\n  height: 2px;\n  background-color: #e6e6e6;\n}\nfi-request-dialog .fi-dialog .fitit-loader .md-bar {\n  background-color: #09aa89;\n}", ""]);

// exports
